// src/utils/Raycaster.js

import { Raycaster as ThreeRaycaster } from 'three';

export class Raycaster extends ThreeRaycaster {
  constructor(origin, direction, near, far) {
    super(origin, direction, near, far);
  }

  intersectObjects(objects, recursive) {
    return super.intersectObjects(objects, recursive);
  }
}


